export const LOGIN_STORE_EMAIL = 'LOGIN_STORE_EMAIL';
export const LOGIN_CURRENT_TAB = 'LOGIN_CURRENT_TAB';
export const CURRENT_REG_INDEX = 'CURRENT_REG_INDEX';
export const setCurrentRegIndexAction = ( index ) => {

    return {
        type: CURRENT_REG_INDEX,
        payload: index
    };

};

export const setLoginAction = ( email ) => {

    return {
        type: LOGIN_STORE_EMAIL,
        payload: email
    };

};

export const setCurrentTabAction = ( index ) => {

    return {
        type: LOGIN_CURRENT_TAB,
        payload: index
    };

};